import { HttpParams } from '@angular/common/http';
import { Injectable, Injector } from '@angular/core';
import { DocumentGroups } from '@carm/_core';
import { BaseApiService } from '@carm/_core/baseapi.service';
import { LoaderSpinnerTypes } from '@carm/_core/models/loader-types.model';
import { Observable } from 'rxjs';
import { ICadDocumentJobStatusResponse, ICadShouldUseAsyncResponse, IStartJobResponse } from '../models';

@Injectable()
export class CadAsyncDocumentsService extends BaseApiService {

  get controllerEnpoint(): string {
    return `${this.endPointBP}/documents/cad-async`;
  }

  constructor(protected injector: Injector) {
    super(injector);
  }

  getDocumentJobStatus(jobId: string): Observable<ICadDocumentJobStatusResponse> {
    const endPoint = `${this.controllerEnpoint}/job-status`;

    const queryParams = new HttpParams()
      .set('jobId', jobId);

    return this.httpAuthGet<ICadDocumentJobStatusResponse>(endPoint, queryParams, LoaderSpinnerTypes.None);
  }

  shouldUseAsync(caseNumber: string, documentGroup: DocumentGroups): Observable<ICadShouldUseAsyncResponse> {
    const endPoint = `${this.controllerEnpoint}/case/${caseNumber}/group/${documentGroup}/should-use-async`;
    return this.httpAuthGet<ICadShouldUseAsyncResponse>(endPoint, null, LoaderSpinnerTypes.None);
  }

  startJob(caseNumber: string, documentGroup: DocumentGroups): Observable<IStartJobResponse> {
    const endPoint = `${this.controllerEnpoint}/case/${caseNumber}/group/${documentGroup}/start-job`;
    return this.httpAuthPost<IStartJobResponse>(endPoint, {});
  }
}
